import { render } from "./BewertungChip.vue?vue&type=template&id=3d97f29c&scoped=true&ts=true"
import script from "./BewertungChip.vue?vue&type=script&lang=ts"
export * from "./BewertungChip.vue?vue&type=script&lang=ts"

import "./BewertungChip.vue?vue&type=style&index=0&id=3d97f29c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d97f29c"]])

export default __exports__